
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		value: {
			type: Number,
		},
		fancy: Boolean,
		label: {
			type: [Object, String]
		},
		allDay: Boolean,
		useGoDays: Boolean,
		disabled: Boolean
	},
	computed: {
		items():ISelectItem<number>[] {
			let a = [0, 1, 2, 3, 4, 5, 6].map(d => {
				let value = d;
				if (this.useGoDays) {
					value++;
					if (value == 7) {
						value = 0;
					}
				}
				return {
					value,
					text: this.$ct(`common.weekday.${d}`).toString()
				} as ISelectItem<number>;
			});

			if (this.allDay){
				a.unshift({value: -1,text: this.$ct(`common.allday`).toString()});
			}

			return a;

		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				let valueIndex = this.items.findIndex(item=>item.value == this.value);
				if (valueIndex != -1) return;
				this.$emit("input", this.items[0].value);
			}
		}
	},
	methods: {
		setValue(val:number) {
			this.$emit("input", val);
		}
	}
});
